import { render, staticRenderFns } from "./ChangeDept.vue?vue&type=template&id=29b96038&scoped=true&"
import script from "./ChangeDept.vue?vue&type=script&lang=js&"
export * from "./ChangeDept.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDept.vue?vue&type=style&index=0&id=29b96038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b96038",
  null
  
)

export default component.exports